export const MEDIFRIEND_ADMIN = 'medifriendAdmin';
export const MEDIFRIEND_TECHNIAN = 'medifriendTechnician';

export const PATIENT = 'patient';
export const PHARMACIST = 'pharmacist';
export const PHARMACY_TECHNICIAN = 'pharmacyTechnician';
export const PHYSICIAN = 'physician';
export const MEDICAL_ASSISTANT = 'medicalAssistant';
export const PHARMACY_USER = 'pharmacyUser';
